export default __webpack_public_path__ + "static/media/product-10 (1).e2340eb7.jpg";